export var translatedLanguages = function translatedLanguages(allowedLanguages, t) {
  return allowedLanguages.map(function (language) {
    return t(language);
  }).join(t('list-separator'));
};
export default translatedLanguages;